import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

/** Estat buit: una invitació, no una disculpa. Mai xifres decoratives (§10.1). */
export function EmptyState({ icon, title, children }: { icon: IconName; title: string; children?: ReactNode }) {
  return (
    <div className="empty">
      <span className="empty-icon"><Icon name={icon} size={28} /></span>
      <h2>{title}</h2>
      {children && <div className="muted">{children}</div>}
    </div>
  );
}
